import { buildReducer } from '../../../shared';
import { LivePersonaCardInitializationState } from '../../state';
import { livePersonaCardInitializeCompletedAction } from '../../actions/lpcActions';

/**
 * This reducer keeps track of whether lpc has been initialized
 */
export default buildReducer<LivePersonaCardInitializationState>()
    .handleDataAction(
        livePersonaCardInitializeCompletedAction,
        () => LivePersonaCardInitializationState.Done,
        () => LivePersonaCardInitializationState.Error
    )
    .done(LivePersonaCardInitializationState.NotInitialized);
export type { Action } from '../../../shared';
